import React from 'react';

import {motion} from 'framer-motion';
import {slideInOut} from '../../animations/commonAnimations';

export default function SearchRecents({query, setQuery, recents, hasResults}) {
    return (

        !hasResults &&
        (!query || query === '') &&
        recents.length > 0 && (
            <motion.div className="col-12 col-md-6 col-lg-12 search__recents" {...slideInOut}>
                <p className="font-weight-bold mb-5">{window.Translator.trans('app.header.search.results.recent_searches')}</p>
                <div className="row gutters-2">
                    {recents.map((recent, recentIndex) => (
                        <div className="col-12" key={recentIndex}>
                            <a
                                type="button"
                                className="list__link text-base font-weight-normal "
                                onClick={() => setQuery(recent)}>
                                {recent}
                            </a>
                        </div>
                    ))}
                </div>
            </motion.div>
        )
    );
}
